module.exports = __webpack_public_path__ + "img/icon-success-onboarding.2c7d3db1.png";